import { render } from "./AlternativeProducts.vue?vue&type=template&id=4b9a7a00"
import script from "./AlternativeProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternativeProducts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/labelinsight-products/components/AlternativeProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b9a7a00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b9a7a00', __exports__)) {
    api.reload('4b9a7a00', __exports__)
  }
  
  module.hot.accept("./AlternativeProducts.vue?vue&type=template&id=4b9a7a00", () => {
    api.rerender('4b9a7a00', render)
  })

}


export default __exports__